<template>
  <div class="pi-bars">
    <p v-if="title" class="pi-bars__title">{{ title }}</p>
    <ul v-if="bars.length" class="pi-bars__list">
      <li v-for="bar in bars" :key="bar.key" class="pi-bars__item">
        <component :is="tagOf(bar)" :to="bar.route || undefined" :type="selectable ? 'button' : undefined" class="pi-bars__row"
                   :class="{ 'is-link': !!bar.route || selectable, 'is-button': selectable, 'is-on': isOn(bar), 'is-dim': isDim(bar) }"
                   :aria-pressed="selectable ? String(isOn(bar)) : undefined" :title="bar.title || null"
                   @click="choose(bar)">
          <span class="pi-bars__label">{{ bar.label }}</span>
          <span class="pi-bars__track" aria-hidden="true">
            <span class="pi-bars__fill" :style="{ width: bar.widthPct + '%' }"></span>
          </span>
          <span class="pi-bars__value">{{ bar.text }}</span>
        </component>
      </li>
    </ul>
    <p v-else class="pi-bars__empty">{{ emptyText }}</p>
  </div>
</template>

<script>
import { normalizeBars } from "./piScale.js";
import { formatValue } from "./piFormat.js";
import { safeInternalRoute } from "./piNavigation.js";

export default {
  name: "pi-bar-list",
  props: {
    rows: { type: Array, default: () => [] },
    unit: { type: String, default: "count" },
    max: { type: Number, default: null },
    title: { type: String, default: "" },
    emptyText: { type: String, default: "Sem dados para listar." },
    selectable: { type: Boolean, default: false },
    selected: { type: String, default: "" },
  },
  computed: {
    bars() {
      const list = (this.rows || []).filter(Boolean).map((row, index) => ({
        key: row.key === undefined || row.key === null ? String(index) : String(row.key),
        label: row.label || "",
        value: typeof row.value === "number" ? row.value : null,
        text: row.valueText || formatValue(row.value, this.unit),
        route: safeInternalRoute(row.to),
        title: row.title || "",
      }));
      return normalizeBars(list, "value", this.max);
    },
  },
  methods: {
    tagOf(bar) {
      if (this.selectable) return "button";
      return bar.route ? "router-link" : "div";
    },
    isOn(bar) {
      return this.selectable && !!this.selected && bar.key === this.selected;
    },
    isDim(bar) {
      return this.selectable && !!this.selected && bar.key !== this.selected;
    },
    choose(bar) {
      if (this.selectable) this.$emit("select", bar.key);
    },
  },
};
</script>

<style scoped>
.pi-bars__title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 700;
  color: #3a424e;
}

.pi-bars__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pi-bars__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 6px;
  border-radius: 4px;
  color: #3a424e;
  text-decoration: none;
}

.pi-bars__row.is-link:hover,
.pi-bars__row.is-link:focus {
  background: #f2f6fe;
  color: #1340b5;
  text-decoration: none;
}

.pi-bars__row.is-button {
  width: 100%;
  border: 1px solid transparent;
  background: transparent;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.pi-bars__row.is-button:hover,
.pi-bars__row.is-button:focus {
  background: #f2f6fe;
  color: #1340b5;
  outline: none;
}

.pi-bars__row.is-on {
  border-color: #1b59f8;
  background: #eef3ff;
  color: #1340b5;
}

.pi-bars__row.is-dim .pi-bars__fill {
  background: #b9cefb;
}

.pi-bars__label {
  flex: 0 0 38%;
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pi-bars__track {
  flex: 1 1 auto;
  height: 12px;
  overflow: hidden;
  border-radius: 3px;
  background: #eceef1;
}

.pi-bars__fill {
  display: block;
  height: 100%;
  background: #1b59f8;
}

.pi-bars__value {
  flex: 0 0 auto;
  min-width: 70px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.pi-bars__empty {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

@media (max-width: 767px) {
  .pi-bars__label {
    flex-basis: 45%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piBarList.vue